import Link from 'next/link'
import { type ReactElement } from 'react'
import { AUTH_REQUEST_MERCHANT_PATH } from '../../../../../../../pages/auth/request-merchants'

export function ForgotMerchantButton (): ReactElement {
  return (
    <Link href={AUTH_REQUEST_MERCHANT_PATH}>
      <div className="text-center block text-xs text-gray-600 p-4">
        Forgot Your Merchant?
      </div>
    </Link>
  )
}
